export default __webpack_public_path__ + "static/media/logo-transparente-cropped.d81fd024.png";